import Q4 from './Q4';

export default Q4;
